import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Routes } from "../../routes";
import { parsedUser } from "../../common/GetCurrentUser";

import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import TotalPurchaseMonthly from "./TotalPurchaseMonthly";
import TotalSaleMonthly from "./TotalSaleMonthly";
import TotalPurchaseYearly from "./TotalPurchaseYearly";
import TotalSaleYearly from "./TotalSaleYearly";
import TotalManualSaleDaily from "./TotalManualSaleDaily";
import TotalFranchiseMonthly from "./TotalFranchiseMonthly";

const DashboardPageContainer = () => {
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const user = parsedUser();
  const { id } = useParams();
  const history = useHistory();
  const [totalMeters, setTotalMeters] = useState(0);
  const SumMeter = (obj) => {
    let count = 0;
    Array.isArray(obj) &&
      obj.forEach((item) => {
        let amount = item.amount - item.previousAmount;
        count += amount;
      });

    setTotalMeters(count);
  };
  const [showCalibration, setShowCalibration] = useState(false);
  const toggleCalibration = () => {
    setShowCalibration(!showCalibration);
  };

  useEffect(() => {
    if (!user) {
      history.push(Routes.SignIn.path);
    }
  }, []);

  return (
    <Container>
      <Row className="mx-0">
        <Col xs={12}>
          <h2>Dashboard</h2>
        </Col>
        <Col xs={12} md={6}>
          <TotalPurchaseYearly />
          <div className="my-2"></div>
          <TotalPurchaseMonthly />
          <div className="my-2"></div>
          <TotalManualSaleDaily />

          <TotalFranchiseMonthly />
        </Col>

        <Col xs={12} md={6}>
          <TotalSaleYearly />
          <div className="my-2"></div>

          <TotalSaleMonthly />
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardPageContainer;
